import http from './http'

let api = {
  getCustomers () {
      return http.postData('/api/admin/customer/chooseList', {})
  },
  getWorkTypes () {
      return http.postData('/api/base/workType/list', {})
  },
  getCityTree () {
    return http.postData('/api/base/city/tree', {})
  },
  getUserInfo () {
    var user = localStorage.getItem('user')
    if (user) {
      var u = JSON.parse(user)
      return u
    }
  }
}

export default api



// WEBPACK FOOTER //
// ./src/util/api.js